var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4242_22102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 0.672852L6.04688 0.672852V2.00618L10.0469 2.00618V0.672852ZM7.38021 9.33952L8.71354 9.33952L8.71354 5.33952H7.38021L7.38021 9.33952ZM12.7335 4.92618L13.6802 3.97952C13.3935 3.63952 13.0802 3.31952 12.7402 3.03952L11.7935 3.98618C10.7602 3.15952 9.46021 2.66618 8.04688 2.66618C4.73354 2.66618 2.04688 5.35285 2.04688 8.66618C2.04688 11.9795 4.72688 14.6662 8.04688 14.6662C11.3669 14.6662 14.0469 11.9795 14.0469 8.66618C14.0469 7.25952 13.5535 5.95952 12.7335 4.92618ZM8.04688 13.3395C5.46688 13.3395 3.38021 11.2529 3.38021 8.67285C3.38021 6.09285 5.46688 4.00618 8.04688 4.00618C10.6269 4.00618 12.7135 6.09285 12.7135 8.67285C12.7135 11.2529 10.6269 13.3395 8.04688 13.3395Z",
    fill: "#44546F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4242_22102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.322e74965683b072524a31b5db05d2db.svg";
export { ForwardRef as ReactComponent };